import { UsersRound, UserCheck, Clock, Network } from 'lucide-react';
import type { FC } from 'react';

interface NetworkStatsCardsProps {
  totalReferrals?: number;
  totalValidated?: number;
  totalPending?: number;
  averageNetworkSize?: number;
}

const NetworkStatsCards: FC<NetworkStatsCardsProps> = ({
  totalReferrals,
  totalValidated,
  totalPending,
  averageNetworkSize,
}) => {
  const items = [
    {
      label: 'Total Referrals',
      value: totalReferrals ?? '—',
      icon: UsersRound,
      color: 'text-blue-600 dark:text-blue-400',
      bg: 'bg-blue-50 dark:bg-blue-900/30',
    },
    {
      label: 'Validés',
      value: totalValidated ?? '—',
      icon: UserCheck,
      color: 'text-emerald-600 dark:text-emerald-400',
      bg: 'bg-emerald-50 dark:bg-emerald-900/30',
    },
    {
      label: 'En attente',
      value: totalPending ?? '—',
      icon: Clock,
      color: 'text-amber-600 dark:text-amber-400',
      bg: 'bg-amber-50 dark:bg-amber-900/30',
    },
    {
      label: 'Taille réseau moy.',
      value: averageNetworkSize != null ? averageNetworkSize.toFixed(1) : '—',
      icon: Network,
      color: 'text-violet-600 dark:text-violet-400',
      bg: 'bg-violet-50 dark:bg-violet-900/30',
    },
  ];

  return (
    <div className="fc-card p-5">
      <h3 className="mb-4 text-xs font-medium uppercase tracking-wider text-slate-500 dark:text-slate-400">
        Détail du réseau
      </h3>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <div key={item.label} className="flex items-center gap-3">
              <div className={`flex h-9 w-9 items-center justify-center rounded-lg ${item.bg}`}>
                <Icon className={`w-4 h-4 ${item.color}`} />
              </div>
              <div className="min-w-0">
                <p className="text-xs text-slate-500 dark:text-slate-400">{item.label}</p>
                <p className="text-lg font-bold text-slate-900 dark:text-white">{item.value}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NetworkStatsCards;
